import React from 'react';

const AccountChooser = ({ accounts, onSelect }) => {
  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Choose an account</h2>
        <div className="space-y-2">
          {accounts.map((account) => (
            <button
              key={account.homeAccountId}
              onClick={() => onSelect(account)}
              className="w-full text-left p-3 bg-gray-100 hover:bg-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <p className="font-semibold">{account.name}</p>
              <p className="text-sm text-gray-600">{account.username}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AccountChooser;